module.exports = __webpack_public_path__ + "static/sanfrancisco-9828b4c61b1825873ffc8389269d5d4d.png";